var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flixColorpicker',{attrs:{"open":false,"value":_vm.color,"callback":function (value) { _vm.color = value; _vm.setSave() }}})
}
var staticRenderFns = []

export { render, staticRenderFns }